import Api from "@coach/js/services/Api";

export default {
  async update(id, payload) {
    return Api.put(`coaching_plan_checkins/${id}`, payload);
  },
  async getCheckin(id, query = null) {
    let request = `coaching_plan_checkins/${id}`;
    if (query) {
      request += "?" + query;
    }
    return Api.get(request);
  },
  async getCheckins(query = null) {
    let request = `coaching_plan_checkins`;
    if (query) {
      request += "?" + query;
    }
    return Api.get(request);
  },
  async sendCheckinEmail(id) {
    return Api.post(`coaching_plan_checkins/${id}/send_email`);
  },
  async sendFeedback(id, message) {
    return this.update(id, { feedback_message: message });
  },
  async markReviewed(id) {
    return this.update(id, { reviewed: true });
  },
  async previewFeedback(id) {
    return Api.get(`coaching_plan_checkins/${id}/preview_feedback`);
  },
  async preview(id) {
    return Api.get(`coaching_plan_checkins/${id}/preview`);
  }
};
